import {
  api_12bb_variables,
  get_axios_instance_12bb,
  get_axios_instance,
  get_axios_file_instance_12BB,
  api_variables,
  errorHandler,
} from "@/apis/variables.js";
const release_axios_instance_it_proof_file_for_payroll= get_axios_instance(
  api_variables.SERVICE_IT_PROOF_ADMIN_RELEASE
);
const uploadFileToS3BucketUrl = get_axios_instance(
  api_variables.SERVICE_IT_PROOF_UPLOAD_S3_BUCKET
)
const deleteFileInS3bucketUrl = get_axios_instance(
  api_variables. SERVICE_IT_PROOF_DELETE_FILE_IN_S3_BUCKET
  )
const get_axios_instance_it_proof_submission = get_axios_instance(
  api_variables.SERVICE_IT_PROOF_SUBMITION_FETCH_ALL
);
const post_axios_instance_it_proof_submission = get_axios_instance(
  api_variables.SERVICE_IT_PROOF_SUBMISSION_POST_ALL
);
const post_axios_instance_it_proof_employee_wise_download = get_axios_instance(
  api_variables.SERVICE_IT_PROOF_EMPLOYEE_WISE_DOWNLOAD
);
const post_axios_instance_it_proof_employee_wise_upload = get_axios_instance(
  api_variables.SERVICE_IT_PROOF_EMPLOYEE_WISE_UPLOAD
);
const download12BBUrl = get_axios_instance_12bb(
  api_12bb_variables.SERVICE_12BB_URL
);
const downloadAllDocumentUrl =get_axios_instance_12bb(
  api_12bb_variables.SERVICE_ALLDOCUMENTS_URL
);
const update12BBUrl = get_axios_file_instance_12BB(
  api_12bb_variables.SERVICE_12BB_UPDATE_URL
);
const fetchItProofDataForIncorparationDate = get_axios_instance(
   api_variables.SERVICE_IT_PROOF_RELEASE_INCORPARATION_FETCH_DATA
);
const fetchBulkPayslipSubCatagory = get_axios_file_instance_12BB(
  api_12bb_variables.SERVICE_BULK_PAYSLIP_CATOGORY);
  const fetchBulkPayslipCatagory = get_axios_instance_12bb(
    api_12bb_variables.SERVICE_BULK_PAYSLIP_DOWNLOAD);
const state = {
  itProofAllDetails: {},
};
const mutations = {
  set_all_it_proof_data: (state, payload) => {
    state.itProofAllDetails = payload;
  },
};
const actions = {
  async fetchAll({ commit }, payload) {
    try {
      console.log("payload Data", payload);
      const res = await get_axios_instance_it_proof_submission.get("", {
        params: {
          employeeId: payload.employeeId,
          legalEntityId: payload.le_id,
          financialYear: payload.financialYear,
          itPlanId: payload.itPlanId,
          regimeType:payload.regimeType
        },
      });
      console.log(res.data.payload);
      return res.data.payload;
    } catch (err) {}
  },
  async releaseItproofForPayrollMonth({ commit }, payload) {
    try {
      const res = await release_axios_instance_it_proof_file_for_payroll.post("", {
        legalEntityId:payload.legalEntityId,
        financialYear:payload.financialYear,
        approvedBy:payload.approvedBy,
      });

      return res.data.payload;
    } catch (err) {
      throw errorHandler(err.response)
    }
  },
  async postAllITProofData({ commit }, payload) {
    try {
      console.log(payload);
      const res = await post_axios_instance_it_proof_submission.post(
        "",
        payload
      );
      console.log(res);
      return res.data;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async employeeWiseDownload({ commit }, payload) {
    try{
  //  let res = await post_axios_instance_it_proof_employee_wise_download.get(`?le_id=${payload.le_id}`)
  //  return res.data
  let res = await post_axios_instance_it_proof_employee_wise_download.get(``, {
    params: payload
  });
  return res;
  }catch(err){
    console.log("errorrrr",err)
    throw errorHandler()
  }
  },
  async employeeWiseUpload({ commit }, payload) {
    try {
      console.log(payload);
      const res = await post_axios_instance_it_proof_employee_wise_upload.post(
        "",
        payload
      );
      console.log(res);
      return res.data;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async form12BBURL({commit},payload){
    try{
      const res =  await download12BBUrl.post(
        "",
        payload
      )
      return res.data
    }catch(err){
      throw errorHandler(err.response)
    }
  },
  async uploadFileToS3Bucket({commit},payload){
    try{
      const res = await uploadFileToS3BucketUrl.post(
        "",
       payload
      )
      return res.data
    }catch(err){
      throw errorHandler(err.response)
    }
  },
  async deleteFileInS3bucket({commit},payload){
    try{
      const res = await deleteFileInS3bucketUrl.post(
        "",
       {
        filename:payload,
        bucketName: process.env.VUE_APP_IT_DOCUMENT ? "payliefuat" :"payliefprod" 
       }
      )
      return res.data
    }catch(err){
      throw errorHandler(err.response)
    }
  },
  async allDocumentsDownload({commit},payload){
    try{
      const res =  await downloadAllDocumentUrl.post(
        "",
        payload
      )
      return res.data
    }catch(err){
      throw errorHandler()
    }
  },
  async update12BBURL ({commit},payload){
    try{
      console.log(payload)
      const res = await update12BBUrl.post("",payload.payload,
      {  params:{
           empCode:payload.empCode,
           legalEntityId:payload.legalEntityId
        }}
      )
      return res
    }catch(err){
      console.log(err)
      throw errorHandler()
    }
  },
  async fetchItProofDataForIncorparationDate({commit},payload){
   try{
    let res = await fetchItProofDataForIncorparationDate.get("/",{
      params:{
        legalEntityId:payload.legalEntityId,
        financialYear:payload.financialYear
      }
    })
    return res.data
   }catch(err){
    throw errorHandler()
   }
  },
  async fetchBulkPayslipSubCatagoryList({commit},payload){
   try{
        console.log("payload",payload.le_id)
     let res = await fetchBulkPayslipSubCatagory.get(payload.le_id)
     return res.data
   }catch(err){
    console.log("errorrrr",err)
     throw errorHandler()
   }
  },
  async fetchBulkPayslipCatagory({commit},payload){
    try{
         console.log("payload",payload)
      let res = await fetchBulkPayslipCatagory.post("/",
        payload
      )
      return res
    }catch(err){
     console.log("errorrrr",err)
      throw errorHandler()
    }
   }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
